export default "__VITE_ASSET__Bjn4r9z0__"